<span>{{ 'SLA' | translate }}:
  <span (click)="toggleSLA()" [ngClass]=" isSLA ? 'is-sla' : 'is-not-sla' ">{{ ( isSLA ? 'YES' : 'NO' ) | translate }}</span>
</span>
